import React, { useState } from 'react';
import styles from './Card.module.scss';
import { Unit } from '../../../../types';
import { getMediaAbsolutePath } from '../../../../services/File';
import IconPencil from 'src/assets/icons/pencil.svg?react';
import FlagAU from 'src/assets/icons/flag_au.svg?react';
import FlagCA from 'src/assets/icons/flag_ca.svg?react';
import FlagUS from 'src/assets/icons/flag_us.svg?react';


type Props = {
  unit: Unit
  handleEditUnit: (unit: Unit) => void
  handleOpenUnit: (unit: Unit) => void
}

const getFlagIcon = (type: String) => {
  switch (type) {
    case "Australia": {
      return <FlagAU />;
    }
    case "Canada": {
      return <FlagCA />;
    }
    case "USA": {
      return <FlagUS />;
    }
    case "Canada & USA": {
      return <><FlagCA /><FlagUS /></>;
    }
    case "All Countries": {
      return <><FlagAU /><FlagCA /><FlagUS /></>;
    }
    default: {
      return null;
    }
  }
}

function Card(props: Props) {
  const [isHovered, setIsHovered] = useState(false);
  const { unit, handleEditUnit, handleOpenUnit } = props

  return (
    <div className={`${isHovered ? styles.cardHovered : styles.card}`} onClick={() => handleOpenUnit?.(unit)} onMouseOver={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}
      style={{ backgroundImage: `url(${unit.coverImage ? getMediaAbsolutePath(unit.coverImage) : ''})` }}>
      <div className={styles.iconView}>
          {getFlagIcon(`${unit.country}`)}
        <div className={styles.editIconWrapper}>
          <IconPencil onClick={() => handleEditUnit(unit)}/>
        </div>
      </div>
      <div className={styles.titleContainer}>
        {unit?.name || ''}
      </div>
    </div>
  );
}

export default Card

